import * as React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";

const Root = styled.div({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  ".slick-track": {
    display: "flex",
  },
  ".slick-track, .slick-slide": {
    display: "flex",
    height: "auto",
    justifyContent: "center",
  },
  ".slick-slide > div > div": {
    height: "100%",
  },
  ".slick-slide > div": {
    height: "100%",
  },
  ".carousel-container": {
    height: "100%",
  },
});

const LeftButton = styled.button({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  appearance: "none",
  padding: 0,
  margin: 0,
  border: 0,
  backgroundColor: "unset",
});

const RightButton = styled.button({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  appearance: "none",
  padding: 0,
  margin: 0,
  border: 0,
  backgroundColor: "unset",
});

function Carousel(props) {
  const { children, gap, itemsToShow } = props;
  const ref = React.useRef();
  const [numItems, setNumItems] = React.useState(1);

  const onLeftClick = () => {
    ref.current.slickPrev();
  };

  const onRightClick = () => {
    ref.current.slickNext();
  };

  React.useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 1000) {
        setNumItems(itemsToShow);
      } else if (window.innerWidth > 800) {
        setNumItems(Math.min(itemsToShow, 2));
      } else {
        setNumItems(1);
      }
    };
    window.addEventListener("resize", onResize);
    onResize();

    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);

  return (
    <Root data-component-name="carousel">
      <LeftButton onClick={onLeftClick}>
        <FontAwesomeIcon
          icon={faChevronLeft}
          style={{ height: 30, width: 30 }}
        />
      </LeftButton>
      <div style={{ maxWidth: "calc(100% - 60px)", height: "fit-content" }}>
        <Slider ref={ref} slidesToShow={numItems} arrows={false}>
          {React.Children.map(children, (child) => (
            <div>
              <div
                className="carousel-container"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: gap !== undefined ? `0px ${gap}px` : undefined,
                }}
              >
                {child}
              </div>
            </div>
          ))}
        </Slider>
      </div>
      <RightButton onClick={onRightClick}>
        <FontAwesomeIcon
          icon={faChevronRight}
          style={{ height: 30, width: 30 }}
        />
      </RightButton>
    </Root>
  );
}

export default Carousel;
